import { Component } from "react"
import PropTypes from "prop-types"

import colors from "foundation/_colors_export.scss?export"
import classnames from "classnames"
import Fittty from "shared/components/fittty"
import { ctaCopyToConnect } from "../utils"
import { expireBFCache } from "shared/scripts/back_forward_cache_utils"

export default class ReconnectButton extends Component {
  state = {
    connected: true,
    playDisableAnimation: false,
    playMeterAnimation: false,
    playSuccessAnimation: false,
    showKnob: this.props.showKnob,
    ctaCopy: "",
    knobBgColor: {
      backgroundColor: `#${this.props.mainService.brand_color}`,
    },
    willDisconnect: false,
  }

  render() {
    const {
      playDisableAnimation,
      playSuccessAnimation,
      playMeterAnimation,
      showKnob,
      connected,
      knobBgColor,
      ctaCopy,
      willDisconnect,
    } = this.state
    const mainService = this.props.mainService
    const showKnobStyle = showKnob ? { opacity: 1 } : { opacity: 0 }

    return (
      <div className="connect-button-outline rc">
        <div style={this.props.defaultBgColor} className="connect-button" onClick={this.handleClick}>
          <div className="meter-container">
            <div
              id="progress-meter"
              className={classnames({
                meter: playMeterAnimation,
              })}
            />
          </div>
          <div
            id="connect-ball"
            className={classnames("service-icon", {
              "slide-in": playDisableAnimation,
              "did-slide": !playDisableAnimation && playMeterAnimation,
              "alt-brand-color": this.props.knobBgColorForDarkBrands,
              "will-disconnect": willDisconnect,
              connected,
            })}
            style={{ ...knobBgColor, ...showKnobStyle }}
          >
            {this.props.dynamicConfig && (
              <img
                alt={mainService.name}
                title={mainService.name}
                src={mainService.lrg_monochrome_image_url || mainService.lrg_variant_image_url}
                width="40"
                height="40"
              />
            )}
          </div>
          <div
            className={classnames("connect-cta", {
              connected,
              "fade-out-fade-in": playSuccessAnimation,
            })}
            id="cta-copy"
          >
            <div className={classnames({ "no-knob": !showKnob })}>
              <Fittty maxSize={this.props.connectButtonMaxFontSize} minSize={14} text={ctaCopy} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleClick = event => {
    event.preventDefault()
    expireBFCache()
    this.props.onConnectClick()
  }

  componentDidMount() {
    if (!this.props.connected && this.state.connected) {
      this.unlatch()
    }
  }

  unlatch = () => {
    const { disconnectClicked } = this.props
    const defaultCtaCopy =
      this.props.ctaCopy || ctaCopyToConnect(this.props.dynamicConfig && this.props.mainService.short_name)

    // don't play aninmations if the flow has not been started in this "session"
    if (!disconnectClicked) {
      this.setState({
        connected: false,
        playDisableAnimation: false,
        playMeterAnimation: false,
        ctaCopy: defaultCtaCopy,
      })
    } else {
      this.knobElement = document.querySelector("#connect-ball")
      this.setState({ willDisconnect: true }, () => {
        requestAnimationFrame(() => {
          this.setState({
            connected: false,
            playDisableAnimation: true,
            showKnob: true,
            ctaCopy: "",
          }, () => {
            this.knobElement.addEventListener("transitionend", this.handleKnobAnimationEnd)
          })
        })
      })
    }
  }

  handleKnobAnimationEnd = () => {
    this.knobElement.removeEventListener("animationend", this.handleKnobAnimationEnd)
    this.meterElement = document.querySelector("#progress-meter")
    this.setState(
      {
        showKnob: false,
        ctaCopy: "Disconnecting…",
        playMeterAnimation: true,
        playDisableAnimation: false,
        playSuccessAnimation: false,
      },
      () => {
        this.meterElement.addEventListener("transitionend", this.handleMeterAnimationEnd)
      }
    )
  }

  handleMeterAnimationEnd = () => {
    this.meterElement.removeEventListener("transitionend", this.handleMeterAnimationEnd)
    this.ctaElement = document.querySelector("#cta-copy")
    this.setState(
      {
        ctaCopy: "Disconnected",
        playMeterAnimation: false,
        playDisableAnimation: false,
        playSuccessAnimation: true,
        willDisconnect: false,
      },
      () => {
        this.ctaElement.addEventListener("animationend", this.handleCtaAnimationEnd)
      }
    )
  }

  handleCtaAnimationEnd = () => {
    const defaultCtaCopy =
      this.props.ctaCopy || ctaCopyToConnect(this.props.dynamicConfig && this.props.mainService.short_name)

    this.setState(
      {
        ctaCopy: defaultCtaCopy,
        showKnob: true,
        playSuccessAnimation: false,
      },
      () => {
        this.ctaElement.removeEventListener("animationend", this.handleCtaAnimationEnd)
      }
    )
  }
}

ReconnectButton.propTypes = {
  mainService: PropTypes.object.isRequired,
  services: PropTypes.array.isRequired,
  onConnectClick: PropTypes.func.isRequired,
  connectClicked: PropTypes.bool.isRequired,
  disconnectClicked: PropTypes.bool.isRequired,
  showKnob: PropTypes.bool,
  ctaCopy: PropTypes.string,
  connected: PropTypes.bool,
  dynamicConfig: PropTypes.bool,
  defaultBgColor: PropTypes.object,
  animation: PropTypes.object.isRequired,
  updateAnimationCol: PropTypes.func.isRequired,
  connectButtonMaxFontSize: PropTypes.number,
  knobBgColorForDarkBrands: PropTypes.bool,
}

ReconnectButton.defaultProps = {
  ctaCopy: "Reconnect",
  defaultBgColor: { backgroundColor: colors.primaryTextColor },
  showKnob: false,
  connected: false,
  connectButtonMaxFontSize: 30,
}
